module.exports = __webpack_public_path__ + "static/media/YF30_0.c53b3147.jpg";